/**
 * Short display for essay dates: "Dec 15", or "Dec 15, 2025" if not the current calendar year.
 * @param {string|Date|null|undefined} isoOrDate
 * @returns {string}
 */
export function formatEssayShortDate(isoOrDate) {
	if (!isoOrDate) return ''
	const d =
		typeof isoOrDate === 'string' || typeof isoOrDate === 'number'
			? new Date(isoOrDate)
			: isoOrDate
	if (Number.isNaN(d.getTime())) return ''
	const now = new Date()
	const opts = { month: 'short', day: 'numeric' }
	if (d.getFullYear() !== now.getFullYear()) {
		opts.year = 'numeric'
	}
	return d.toLocaleDateString('en-US', opts)
}

/**
 * Feedback thread message header: today → time only; otherwise date + time;
 * year shown when the message is not in the current calendar year.
 * @param {string|Date|null|undefined} isoOrDate
 * @returns {string}
 */
export function formatFeedbackThreadTimestamp(isoOrDate) {
	if (!isoOrDate) return ''
	const d =
		typeof isoOrDate === 'string' || typeof isoOrDate === 'number'
			? new Date(isoOrDate)
			: isoOrDate
	if (Number.isNaN(d.getTime())) return ''
	const now = new Date()
	const timeStr = d.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: '2-digit',
	})

	const sameCalendarDay =
		d.getFullYear() === now.getFullYear() &&
		d.getMonth() === now.getMonth() &&
		d.getDate() === now.getDate()

	if (sameCalendarDay) {
		return timeStr
	}

	const sameYear = d.getFullYear() === now.getFullYear()
	const dateOpts = { month: 'short', day: 'numeric' }
	if (!sameYear) {
		dateOpts.year = 'numeric'
	}
	const dateStr = d.toLocaleDateString('en-US', dateOpts)
	return `${dateStr}, ${timeStr}`
}
